<template>
  <div>
    <el-upload
      ref="upload"
      :class="{ disabled: uploadDisabled || isLimitBeyond }"
      style="width: 100%"
      name="file"
      :action="filePath"
      :headers="header"
      :list-type="listType"
      :file-list="fileList"
      :show-file-list="true"
      :on-error="handleUploadError"
      :before-upload="handleBeforeUpload"
      :on-success="uploadSuccess"
      :on-progress="onProgress"
      :on-exceed="handleExceed"
      :data="{ code }"
      :limit="limit"
      :accept="_accept"
      :disabled="disabled"
      v-bind="$attrs"
    >
      <slot>
        <i class="el-icon-plus"></i>
      </slot>
      <slot name="tip" slot="tip">
        <div class="el-upload__tip" style="width: 148px; text-align: center">
          {{ instructionText }}
        </div>
      </slot>
      <slot name="file" slot="file" slot-scope="{ file }" v-bind="{ file }">
        <div>
          <el-image
            v-if="isImage(file)"
            ref="previewImg"
            style="border-radius: 6px; width: 148px; height: 148px"
            :src="file.url"
            :preview-src-list="[clickFileUrl]"
          />
          <div v-else class="box font-12 color-999">
            <i class="el-icon-document font-24"></i>
            <span>{{ isPdf ? 'PDF' : '' }}文件已上传</span>
            <span>可下载预览</span>
          </div>
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
              v-if="isImage(file)"
            >
              <i class="el-icon-zoom-in"></i>
            </span>
            <span class="el-upload-list__item-delete" @click="handleDownload(file)">
              <i class="el-icon-download"></i>
            </span>
            <span class="el-upload-list__item-delete" @click="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
      </slot>
    </el-upload>
  </div>
</template>

<script>
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import { isEmpty } from 'lodash-es'

  export default {
    props: {
      instructionText: {
        type: String,
        default: ''
      },
      file: {
        type: Array,
        default: () => []
      },
      limit: {
        type: Number,
        default: 0
      },
      accept: {
        type: String,
        default: () => '.jpg,.jpeg,.png,.gif,.svg,.webp,.JPG,.JPEG,.PNG,.GIF,.SVG,.WEBP'
      },
      isMultiple: {
        type: Boolean,
        default: false
      },
      code: {
        type: String,
        default: 'unknown'
      },
      listType: {
        type: String,
        default: 'picture-card'
      },
      // 上传图片大小限制 默认2M
      size: {
        type: Number,
        default: 2
      },
      // 上传图片宽高限制 默认无限制
      maxWidth: {
        type: Number,
        default: 0
      },
      // 上传图片宽高限制 默认无限制
      maxHeight: {
        type: Number,
        default: 0
      },
      // 指定图片宽高，默认无限制
      width: {
        type: Number,
        default: 0
      },
      // 指定图片高度，默认无限制
      height: {
        type: Number,
        default: 0
      },
      // 禁用
      disabled: {
        type: Boolean,
        default: false
      },
      isPdf: {
        // 是否支持pdf
        type: Boolean,
        default: false
      },
      customTip: {
        type: Object,
        default: null
      }
    },
    computed: {
      isLimitBeyond() {
        if (this.limit) {
          return this.fileList.length >= this.limit
        }
        return false
      },
      _accept() {
        const acceptStr = '.jpg,.jpeg,.png,.gif,.svg,.webp,.JPG,.JPEG,.PNG,.GIF,.SVG,.WEBP'
        if (this.isPdf) {
          return acceptStr + ',.pdf'
        }
        if (this.accept === 'image/*') {
          return acceptStr
        }
        return this.accept
      }
    },
    data() {
      return {
        filePath: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        // filePath: 'https://custom-pre.ayundi.cn' + env.ferryUrl + '/oss/uploadV2',
        header: { Authorization: 'bearer ' + getToken() },
        fileList: [],
        uploadList: [],
        uploadDisabled: false,
        list: [],
        clickFileUrl: ''
      }
    },
    mounted() {
      this.fileList = this.file
    },
    watch: {
      fileList(val) {
        if (!this.isMultiple) {
          if (val.length > 0) {
            this.uploadDisabled = true
          }
        }
      }
    },
    methods: {
      parsePercentage(val) {
        return parseInt(val, 10)
      },
      isImage(file) {
        const { name, url } = file || {}
        const reg = /\.(gif|png|jpg|jpeg|webp|svg|psd|bmp|tif)/gi
        return reg.test(url) || reg.test(name)
      },
      validateSize(file) {
        return new Promise((resolve) => {
          const reader = new FileReader()
          reader.onload = (e) => {
            const data = e.target.result
            const image = new Image()
            image.onload = () => {
              const width = image.width
              const height = image.height
              if (this.width || this.height) {
                if (this.width && width !== this.width) {
                  this.$message.error(`请上传宽为${this.width}像素的图片`)
                  resolve(false)
                  return
                }
                if (this.height && height !== this.height) {
                  this.$message.error(`请上传高为${this.height}像素的图片`)
                  resolve(false)
                  return
                }
                resolve(true)
                return
              }
              if (this.maxHeight || this.maxWidth) {
                if (this.maxWidth && width > this.maxWidth) {
                  this.$message.error(`请上传宽不超过${this.maxWidth}像素的图片`)
                  resolve(false)
                  return
                }
                if (this.maxHeight && height > this.maxHeight) {
                  this.$message.error(`请上传高不超过${this.maxHeight}像素的图片`)
                  resolve(false)
                  return
                }
                resolve(true)
                return
              }
              resolve(true)
            }
            image.src = data
          }
          reader.readAsDataURL(file)
        })
      },
      async handleBeforeUpload(file) {
        const { type, size } = file || {}
        if (file.name && file.name.length > 80) {
          this.$message.error('文件名称不能超过80字!')
          return Promise.reject(new Error('文件名称不能超过80字！'))
        }
        // 判断文件类型
        const suffix = type ? type.substring(type.lastIndexOf('/') + 1) : ''
        if (!this._accept.includes(suffix)) {
          const msg = `请上传后缀为${this._accept}的文件`
          this.$message.error(msg)
          return Promise.reject(new Error(msg))
        }

        // 判断图片尺寸是否符合要求
        if (this.isImage(file)) {
          let inSize = false
          if (this.customTip && typeof this.customTip === 'function') {
            const { width, height } = await this.getImgSize(file)
            inSize = await this.customTip({
              imgWidth: width,
              imgHeight: height,
              width: this.width,
              height: this.height,
              maxWidth: this.maxWidth,
              maxHeight: this.maxHeight
            })
          } else {
            inSize = await this.validateSize(file)
          }
          if (!inSize) {
            return Promise.reject(new Error('图片尺寸不符合要求'))
          }
        }

        if (!this.isMultiple) {
          this.uploadDisabled = true
        }

        return new Promise((resolve, reject) => {
          // 判定文件大小是否小于sizeMB
          const isLt2M = size / 1024 / 1024 < this.size
          if (isLt2M) {
            resolve(file)
            return
          }
          if (type.includes('image/')) {
            // 压缩到400kb
            const imageConversion = require('image-conversion')
            imageConversion.compressAccurately(file, 400).then((res) => {
              resolve(res)
            })
          } else if (suffix === 'pdf') {
            // 对于 PDF 文件，不进行压缩，直接上传
            resolve(file)
          } else {
            const tip = `上传的文件大小不能超过${this.size}M`
            this.$message.error(tip)
            reject(new Error(tip))
          }
        })
      },
      onProgress(event, file, fileList) {
        this.$emit('progress', event, file, fileList)
      },
      uploadSuccess(res, file, fileList) {
        if (!res.data) {
          this.$message.error(res.msg || '上传文件失败，请重试')
          return
        }
        const { type } = file || {}
        const uploadFiles = this.$refs.upload ? this.$refs.upload.uploadFiles : []
        if (isEmpty(res.data)) {
          this.$message.error(res.msg)
          this.uploadDisabled = false
          return
        }
        const suffix = type ? type.substring(type.lastIndexOf('/') + 1) : ''
        if (!this._accept.includes(suffix)) {
          this.handleRemove(file)
          return
        }
        const paramArr = []
        console.log(uploadFiles)
        if (uploadFiles.length) {
          uploadFiles.forEach((it, i) => {
            const fileName = it.name || (it.raw ? it.raw.name : '')
            if (!it.response) {
              paramArr.push({
                name: it.url.split('.cn/')[1],
                url: it.url,
                fileName
              })
            } else {
              paramArr.push({
                name: it.response.data.name,
                url: it.response.data.url,
                fileName
              })
            }
          })
        }
        this.$emit('uploadSuccess', paramArr)
        if (!this.isMultiple) {
          this.uploadDisabled = true
        }
        this.fileList = fileList
      },
      // 上传失败
      handleUploadError() {
        this.$message.error('上传失败，请重试')
        this.uploadDisabled = false
      },
      handleRemove(file) {
        const uploadFiles = this.$refs.upload ? this.$refs.upload.uploadFiles : []
        for (const i in uploadFiles) {
          if (file.url === uploadFiles[i].url) {
            uploadFiles.splice(i, 1)
          }
        }
        const paramArr = []
        if (uploadFiles.length) {
          uploadFiles.forEach((it, i) => {
            if (!it.response) {
              paramArr.push({
                name: it.url.split('.cn/')[1],
                url: it.url
              })
            } else {
              paramArr.push({
                name: it.response.data.name,
                url: it.response.data.url
              })
            }
          })
        }
        this.$emit('remove', paramArr)
        this.uploadDisabled = false
        this.fileList = paramArr
      },
      // 预览
      handlePictureCardPreview(data) {
        this.clickFileUrl = data.url
        if (!this.$refs.previewImg) {
          return
        }
        this.$refs.previewImg.showViewer = true
      },
      // 下载  imgage图片blob类型下载
      handleDownload(file) {
        window.open(file.url)
      },
      // 文件个数超出
      handleExceed() {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`)
      },
      getImgSize(imgFile) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }

  .box {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
